import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const StContainer = styled.div`
  position: relative;
  cursor: pointer;
  ${({ theme }) => `
    width: ${theme.UI.SpacingPx.Space6};
    height: ${theme.UI.SpacingPx.Space6};
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  width: 100%;
  height: 100%;
`

const StBadge = styled.span`
  position: absolute;
  top: -7px;
  right: -7px;
  background-color: ${({ theme }) => theme.Colors.Status.Error};
  color: ${({ theme }) => theme.Colors.Background.White};
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => theme.Colors.Neutrals.Lighter};
  z-index: 2;
`

export { StBadge, StContainer, StIcon }
